import React from 'react';
import MokaDatePicker from 'components/receipt/invoices/RecordPaymentModal/MokaDatePicker';
import PhoneNumberField from 'components/Fields/ReduxForm/PhoneNumberField';
import { Field } from 'redux-form';
import { formatDecimal } from 'utils/formatter';
import { connect } from 'react-redux';
import Slideshow from 'components/Slideshow';
import {
  Months,
  gender,
  relationshipStatus,
  listOfBank,
  maritalStatus,
  textAreaField,
  numberOnly,
  alphaNumeric,
  alphabeticalAndSomeChar,
  alphabeticalOnly,
  inputField,
  renderSelectField,
} from './utilsForm';
import UploadFile from './UploadFile';
import styles from './DetailForm.css';

class TaraliteForm extends React.Component {
  state = {
    showSlideshow: false,
  };

  bankTutorialSrc = [
    [
      'Panduan Dokumen',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/PanduanDokumen.png',
    ],
    [
      'BCA',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/BCA.png',
    ],
    [
      'BNI',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/BNI.png',
    ],
    [
      'Mandiri',
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/MAndiri.png',
    ],
  ];

  componentWillMount() {
    // load the image before mount, to avoid empty image container when user clicking bankTutorial
    this.bankTutorialSrc.forEach(bank => {
      const img = document.createElement('img');
      [, img.src] = bank;
    });
  }

  openSlideshow() {
    this.setState({ showSlideshow: true });
  }

  closeSlideshow() {
    this.setState({ showSlideshow: false });
  }

  static downloadBankTutorial() {
    const bankTutorialPDF =
      'https://s3-ap-southeast-1.amazonaws.com/backoffice-exp-capital.mokapos.com/bankTutorial/Bank+Statement+Tutorial+-+KoinWorks+-+KoinBisnis.pdf';
    const a = document.createElement('a');
    const clickEvent = new window.MouseEvent('click');
    a.setAttribute('href', bankTutorialPDF);
    a.setAttribute('download', bankTutorialPDF);
    a.setAttribute('target', '_blank');
    a.dispatchEvent(clickEvent);
  }

  render() {
    const {
      businessLocationsState,
      businessStartsState,
      sendingRequest,
      logo,
      preApprovedAmount,
      interestRate,
      duration,
      lenderName,
      monthlyInstallment,
      bankName,
      onClickChange,
    } = this.props;
    return (
      <div className={styles.wrapper}>
        {
          // modal slideshow
          <Slideshow
            showModal={this.state.showSlideshow}
            imageSrc={this.bankTutorialSrc.map(bank => bank[1])}
            imageAlt={this.bankTutorialSrc.map(bank => bank[0])}
            onCloseButtonClicked={this.closeSlideshow.bind(this)}
          />
        }
        <div
          className={`col-md-12 ${styles['div-body']} spacer ${
            styles['no-padding']
          } ${styles['box-list']} ${styles['box-scroll']}`}
        >
          <div className={`col-md-12 ${styles['box-body']}`}>
            <table className="col-md-12 col-lg-12">
              <tr>
                <td className={`text-center ${styles['lender-logo']}`}>
                  <img src={logo} />
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Lender</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {lenderName}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Loan Amount</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(preApprovedAmount)}
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Rate p.a.</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {interestRate}%
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>Tenure</p>
                  <p className={`${styles['lender-sub-title']}`}>
                    {duration} months
                  </p>
                </td>
                <td className={`text-center`}>
                  <p className={`${styles['lender-title']}`}>
                    Monthly Instalment
                  </p>
                  <p className={`${styles['lender-sub-title']}`}>
                    IDR {formatDecimal(monthlyInstallment)}/month
                  </p>
                </td>
                <td className={`text-center`}>
                  <a onClick={onClickChange} className="btn btn-link">
                    Change
                  </a>
                </td>
              </tr>
            </table>
            <div className="col-md-12 col-lg-12">
              <hr />
              <p className={styles['float-right']}>
                <red>*</red>
                Required
              </p>
            </div>
          </div>
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label>Personal Information</label>
              <p>Please fill in the information of the business owner</p>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  First Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="first_name"
                    maxLength="255"
                    placeholder="Your First Name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Last Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="last_name"
                    maxLength="255"
                    placeholder="Your Last Name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Email
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="email"
                    maxLength="255"
                    placeholder="Email"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Phone Number
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={PhoneNumberField}
                    name="phone_number"
                    type="tel"
                    placeholder=""
                    errorRegister
                    showTextError
                    customClassName={styles['account-name']}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  KTP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="nik"
                    maxLength="16"
                    placeholder="Your KTP"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={numberOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  NPWP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="npwp_no"
                    maxLength="15"
                    placeholder="Your NPWP"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={numberOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Gender
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    name="gender"
                    className={`form-control ${styles['bank-select']}`}
                    id="gender"
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Select Your Gender
                    </option>
                    {gender.map(option => (
                      <option value={option.value} key={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Marital Status
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    name="marital_status"
                    className={`form-control ${styles['bank-select']}`}
                    id="marital_status"
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Select Your Marital Status
                    </option>
                    {maritalStatus.map(option => (
                      <option value={option.value} key={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Place of Birth
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="place_of_birth"
                    maxLength="255"
                    placeholder="Place of Birth"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Date of Birth
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={MokaDatePicker}
                    name="birth_date"
                    placeholder="YYYY-MM-DD"
                    readOnly={false}
                    showMonthDropdown
                    showYearDropdown
                    errorClassName={styles.error}
                    className={`form-control ${styles['account-name']}`}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Mother Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="mother_name"
                    maxLength="255"
                    placeholder="Your Mother Name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Personal Address
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="address"
                    maxLength="255"
                    placeholder="Your Personal Address"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    component={inputField}
                    name="home_city"
                    maxLength="255"
                    placeholder="City"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    name="home_province"
                    className={`form-control ${styles['bank-select']}`}
                    id="business_location _id"
                    component={renderSelectField}
                  >
                    <option key={0} value="">
                      Select Province...
                    </option>
                    {businessLocationsState.map(option => (
                      <option value={option.name} key={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    component={inputField}
                    name="home_zipcode"
                    maxLength="5"
                    placeholder="Zip"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={numberOnly()}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <hr />
            </div>
          </div>
          <div className="col-md-12 col-lg-12">
            <div className="col-md-3">
              <label>Bank Information</label>
              <p>Account holder name has to be the same as applicant name</p>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Bank Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    name="bank_name"
                    className={`form-control ${styles['bank-select']}`}
                    id="bank_name"
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Select Your Bank Name
                    </option>
                    {listOfBank.map(option => (
                      <option value={option.name} key={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                  {bankName === 'Other' && (
                    <Field
                      component={inputField}
                      name="other_bank_name"
                      maxLength="255"
                      placeholder="Your Bank Name"
                      autoCorrect="off"
                      autoCapitalize="off"
                      spellCheck="false"
                      className={`form-control ${styles['account-name']}`}
                      normalize={alphaNumeric()}
                    />
                  )}
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Personal Bank Account Number
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="account_no"
                    maxLength="16"
                    minLength="10"
                    placeholder="Account Number"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={numberOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Personal Bank Account Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="bank_account_name"
                    maxLength="255"
                    placeholder="Account Name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphaNumeric()}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <hr />
            </div>
          </div>
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label>Business Information</label>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Business Name<red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="business_name"
                    maxLength="255"
                    placeholder="Your business/company name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  When Does <br /> Your Business Start?<red>*</red>
                </label>
                <div className="col-sm-4 col-lg-2">
                  <Field
                    name="business_start_month"
                    className={`form-control ${styles['bank-select']}`}
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Month...
                    </option>
                    {Months.map(option => (
                      <option value={option.value} key={option.value}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
                <div className="col-sm-4 col-lg-2">
                  <Field
                    name="business_start_year"
                    className={`form-control ${styles['bank-select']}`}
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Year...
                    </option>
                    {businessStartsState.map(option => (
                      <option value={option.code} key={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Business Address<red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="business_address"
                    maxLength="255"
                    placeholder="Your Business Address"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    component={inputField}
                    name="business_city"
                    maxLength="255"
                    placeholder="City"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    name="business_province"
                    className={`form-control ${styles['bank-select']}`}
                    id="business_location _id"
                    component={renderSelectField}
                  >
                    <option key={0} value="">
                      Select Province...
                    </option>
                    {businessLocationsState.map(option => (
                      <option value={option.name} key={option.id}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
                <div className="col-sm-offset-4 col-sm-8">
                  <Field
                    component={inputField}
                    name="business_zipcode"
                    maxLength="5"
                    placeholder="Zip"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={numberOnly()}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <hr />
            </div>
          </div>
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label>Emergency Contact</label>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Name
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={inputField}
                    name="name_emergency"
                    maxLength="255"
                    placeholder="Name"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalOnly()}
                  />
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Relationship
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    name="relationship"
                    className={`form-control ${styles['bank-select']}`}
                    id="relationship"
                    component={renderSelectField}
                  >
                    <option value="" key="">
                      Select Your Relationship
                    </option>
                    {relationshipStatus.map(option => (
                      <option value={option.value} key={option.name}>
                        {option.name}
                      </option>
                    ))}
                  </Field>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Contact Number
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <Field
                    component={PhoneNumberField}
                    name="contact_number_emergency"
                    type="tel"
                    placeholder=""
                    errorRegister
                    showTextError
                    customClassName={styles['account-name']}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <hr />
            </div>
          </div>
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label className={`${styles['title-information']}`}>
                Your Reason for Having a loan
              </label>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className="col-sm-4 col-form-label"
                >
                  Reason
                  <red>*</red>
                  <br />
                  (max 255 characters)
                </label>
                <div className="col-sm-8">
                  <Field
                    component={textAreaField}
                    name="loan_purpose"
                    maxLength="255"
                    placeholder="Your Reason for Having a Loan"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className={`form-control ${styles['account-name']}`}
                    normalize={alphabeticalAndSomeChar()}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <hr />
            </div>
          </div>
          <div className={`col-md-12 col-lg-12`}>
            <div className="col-md-3">
              <label className={`${styles['title-information']}`}>
                Required Document
              </label>
              <p>Please scan and upload following documents.</p>
              <p>
                Format file should be <b>jpg, png, jpeg or pdf</b>
              </p>
              <p>
                File size should be less than <b>2MB</b>
              </p>
            </div>
            <div className="col-md-9">
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Kartu Keluarga
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="kk"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  KTP
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="ktp"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
              <div className="form-group row">
                <label
                  htmlFor="inputEmail3"
                  className={`col-sm-4 ${styles['upload-label']}`}
                >
                  Verification Photo (self photo with KTP)
                  <red>*</red>
                </label>
                <div className="col-sm-8">
                  <div
                    className={`${styles['float-right']} ${
                      styles['full-width']
                    }`}
                  >
                    <Field
                      type="file"
                      name="verification_photo"
                      component={UploadFile}
                      className={`${styles['form-control-file']}`}
                      allowPDF
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-lg-12">
              <p className={styles['float-right']}>
                <red>*</red>
                Required
              </p>
              <br />
              <hr />
              <button
                className={`btn ${styles['btn-upload-green']} `}
                disabled={sendingRequest}
                type="submit"
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(TaraliteForm);
